const getTopicInfo = (topic, filterId): ITopicInfo => {
  const content =
    topic?.content?.materials?.find((material) => {
      return material?.material?.filter?.value + "" === filterId;
    }) ||
    topic?.content?.materials?.[0] ||
    null;

  return {
    urlname: topic.urlname,
    title: content?.material?.title,
    filter_id: filterId || content?.material?.filter?.value || null,
  };
};

export default getTopicInfo;
